module.exports = __webpack_public_path__ + "img/icon-cart-2.e2dcca74.svg";